import {
  Avatar,
  Flex,
  Stack,
  Text,
  Tooltip,
  useColorModeValue,
} from "@chakra-ui/react";
import dayjs from "dayjs";
import { doc, onSnapshot } from "firebase/firestore";
import { useEffect, useState } from "react";
import { IoImageOutline } from "react-icons/io5";
import { useGetState } from "../../context/useGetState";
import { photoBaseURL } from "../../service/api";
import { db } from "../../service/firebase";
import { trunc } from "../../utils";
import thelogo from "../../assets/thelogo.png"

function formatDate(created_at) {
  const currentDate = new Date();
  const createdAtDate = new Date(created_at);
  
  // Get the time in format 3:48 if created today
  if (
    currentDate.getDate() === createdAtDate.getDate() &&
    currentDate.getMonth() === createdAtDate.getMonth() &&
    currentDate.getFullYear() === createdAtDate.getFullYear()
  ) {
    const hours = createdAtDate.getHours();
    const minutes = createdAtDate.getMinutes();
    return `${hours}:${minutes < 10 ? '0' : ''}${minutes}`;
  }
  
  // Get 'yesterday' if created yesterday
  const yesterday = new Date(currentDate);
  yesterday.setDate(currentDate.getDate() - 1);
  if (
    yesterday.getDate() === createdAtDate.getDate() &&
    yesterday.getMonth() === createdAtDate.getMonth() &&
    yesterday.getFullYear() === createdAtDate.getFullYear()
  ) {
    return 'Yesterday';
  }
  
  // Get the weekday if less than 7 days
  const daysDifference = Math.floor(
    (currentDate - createdAtDate) / (1000 * 60 * 60 * 24)
  );
  if (daysDifference < 7) {
    const weekdays = ['Sunday', 'Monday', 'Tuesday', 'Wednesday', 'Thursday', 'Friday', 'Saturday'];
    return weekdays[createdAtDate.getDay()];
  }
  
  // Get the date in format 09/12/23 if more than 7 days
  const formattedDate = `${createdAtDate.getDate()}/${createdAtDate.getMonth() + 1}/${createdAtDate
    .getFullYear()
    .toString()
    .slice(-2)}`;
  return formattedDate;
}

function ExternalUserChatProfile({ id, group, value, userInfo, incomingLastMessage }) {
  const usernameColor = useColorModeValue("#4B5155", "#526075");
  const [isTyping, setIsTyping] = useState({});
  const { username } = userInfo || {};

  //update the 'last_message' property of a 'group' object with data from 'incomingLastMessage'
  if (incomingLastMessage) {
    if (parseFloat(incomingLastMessage?.group_id) === parseFloat(group?.id)) {
      group.last_message = {
        ...(group.last_message || {}), // Ensure group.last_message is an object
        message: incomingLastMessage.message,
        file: incomingLastMessage.file,
        sender: incomingLastMessage.sender,
        created_at: incomingLastMessage.created_at,
        reads: incomingLastMessage.reads,
      };
    }
  }

  return (
    <Stack direction={"row"} alignItems="flex-start">
      <Avatar
        border={"2px solid #fff"}
        size={"sm"}
        fallbackSrc={thelogo}
        src={group?.picture}
        name={group?.name}
      />
      <Stack
        alignItems={"flex-start"}
        spacing="0.9"
        direction={"row"}
        justifyContent="space-between"
        w="100%"
      >
        <Stack>
          <Text color={usernameColor} fontSize=".8em">
            {trunc(group?.name, 15)}
          </Text>
          <Flex width={"100%"} justify="start" align={"center"}>
            <Text mr="5px" color="#7B8793" fontSize={".8em"}>
              {

              userInfo?.username === group?.last_message?.sender?.username ? (
                "You:"
              ) : (
                `${
                  group?.last_message?.sender
                    ? `${trunc(group?.last_message?.sender?.username, 10)}:`
                    : ""
                }`
              )}
            </Text>
 
            {
              group?.last_message?.message !== 'null' ? (
                <Tooltip label={group?.last_message?.message}>
                  <Text mt="2px" color="#7B8793" fontSize={".66em"}>
                    {trunc(group?.last_message?.message, 10)}
                  </Text>
                </Tooltip>
              ) : group?.last_message?.file ? (
                <IoImageOutline fontSize={"1em"} color="#afbbc6" />
              ) : (
                ""
              )
            }
              <Tooltip label={group?.last_message?.message}>
                <Text mt="2px" color="#7B8793" fontSize={".66em"} display={"none"}>
                  {trunc(group?.last_message?.message, 10)}
                </Text>
              </Tooltip>
          </Flex>
        </Stack>
        {group?.last_message?.message && (
          <Text color="#7B8793" fontSize={".7em"} flex="3" textAlign={"right"}>
            {formatDate(group?.last_message?.created_at)}
          </Text>
        )}

      </Stack>
    </Stack>
  );
}

export default ExternalUserChatProfile;
